import PropTypes from 'prop-types';
export const breadcrumbsPropTypes = {
  /**
   * Breadcrumbs, array of objects: label, title and href
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    title: PropTypes.string,
    href: PropTypes.string
  }))
};